import { render, staticRenderFns } from "./AppMillion.vue?vue&type=template&id=c3d84b20&scoped=true&"
import script from "./AppMillion.vue?vue&type=script&lang=js&"
export * from "./AppMillion.vue?vue&type=script&lang=js&"
import style0 from "./AppMillion.vue?vue&type=style&index=0&id=c3d84b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d84b20",
  null
  
)

export default component.exports